import {
  } from '../utils/nmStrPricingEngine';

let nmPricingReferences = [];

export function loadNmPricingReferencesFromDB(rows = []) {
  nmPricingReferences = Array.isArray(rows) ? rows : [];
  return nmPricingReferences;
}

export function getNmPricingReferences() {
  return nmPricingReferences;
}

